export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('EditThisPage', () => {
        return {
          show: false,

          toggle() {
            this.show = !this.show;
          },

          init() {
            const config = JSON.parse(localStorage.getItem('config'));

            if (config?.collections?.editShortcuts) {
              this.show = true;
            }
          },
        };
      });
    });
  },
};
